import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, concatMap, map, tap } from 'rxjs/operators';

import { AdminBackend } from '@libs/src/admin/admin.backend';
import { ToastService } from '@libs/src/toast/toast.service';

import {
  DeleteProfileError,
  PROFILE_DELETE_ACCOUNT,
  ProfileAction,
  ResetProfile,
} from '@main-client/src/app/profile/profile-store/profile.actions';

declare let window: any;

@Injectable()
export class ProfileEffectsService {
  deleteProfile: Observable<ProfileAction> = createEffect(() =>
    this.actions.pipe(
      ofType(PROFILE_DELETE_ACCOUNT),
      tap(() => this.toastService.show('Deleting account...')),
      concatMap((action: ProfileAction) => {
        return this.adminBackend
          .deleteAccount(action.payload.account, action.payload.params)
          .pipe(
            tap(() => {
              return 1 === window.history.length
                ? this.router.navigate(['/home'])
                : this.location.back();
            }),
            map(() => {
              this.toastService.showSuccess(
                $localize`:@@customToast.deleteAccount.successMessage:${action.payload.account.email} is now deleted`,
              );
              return ResetProfile();
            }),
            catchError((responseError: any) => {
              const errorMessage =
                responseError.error && responseError.error.message;
              this.toastService.showError(
                errorMessage ||
                  `Something went wrong while deleting the account. Please try again later.`,
              );
              return of(DeleteProfileError());
            }),
          );
      }),
    ),
  );

  constructor(
    private actions: Actions,
    private adminBackend: AdminBackend,
    private http: HttpClient,
    private location: Location,
    private router: Router,
    private toastService: ToastService,
  ) {}
}
